<!--
   Copyright 2022-2024 NXGN Management, LLC. All Rights Reserved.
-->
<nav id="menu">
  <ul class="nav nav-pills flex-column sideMargin">
    <li role="presentation" class="inverse nav-item">
      <a routerLink="/home" class="nav-link">
        <span>
          <fa-icon [icon]="faDesktop" size="lg"></fa-icon>
        </span>
        Dashboard
      </a>
    </li>

    <li role="presentation" class="nav-item">
      <a routerLink="/merchants" class="nav-link">
        <span>
          <fa-icon [icon]="faMoney"></fa-icon>
        </span>
        Merchants
      </a>
    </li>
    <li role="presentation" class="submenu nav-item">
      <a routerLink="/merchants" class="nav-link">
        <span>
          <fa-icon [icon]="faSearch" size="sm"></fa-icon>
        </span>
        search for merchant
      </a>
    </li>
    <li role="presentation" class="submenu nav-item" *ngIf="hasFinanceRole">
      <a routerLink="/merchants/add" class="nav-link">
        <span>
          <fa-icon [icon]="faPlus" size="sm"></fa-icon>
        </span>
        add new merchant
      </a>
    </li>
    <li role="presentation" class="toggle" (click)="hideMenu()">
      <span>
        <fa-icon [icon]="faChevronLeft" size="2x"></fa-icon>
      </span>
    </li>
  </ul>
</nav>
